import {
  MetricData,
  OverviewData,
  OverviewDailyData,
  OverviewDeviceData,
  OverviewDeviceAdData,
} from 'types';

// TOOLTIPS
export const OVERVIEW_TOOLTIPS_TEXT = {
  Coverage: [
    'Percent of time a brand appeared on a search',
    'term/number of times the keyword was',
    'queried during a selected time period',
  ],
  Rank: [
    'Average of all positions for a given',
    'advertiser/total number of positions',
    'possible (or results displayed) when seen',
  ],
  '# Search Terms': [
    'Search terms tracked on the SERP with',
    'chosen engine, location, language, and',
    'study type assignment',
  ],
};

// TAB OPTIONS
export const OVERVIEW_TABS = ['Coverage', 'Rank', '# Search Terms'] as const;

// OSM-1861 / OSM-1862 / OSM-1875 — engine allow-list. Canonical hub lives in
// `pfx-onesearch-v2-frontend/myapp/validators.py` (see ALLOWED_ENGINES). If
// you change the values here, also update:
//   - pfx-onesearch-v2-frontend/myapp/validators.py
//   - pfx-onesearch-v2-backend/data_collection/oxylabs_data/oxylabs_data.py
//       (`ALLOWED_OXYLABS_ENGINES`, lowercase)
//   - pfx-onesearch-v2-frontend/myapp/static/myapp/onboarding_templates/
//       Competitive_Intelligence.xlsx (`geotargetting!A` data-validation list)
// Casing matters: values are written verbatim to the BigQuery view
// `compint_study_keywords` and matched (case-insensitively) by the SERP
// request builders.
export const ALLOWED_ENGINES = ['Bing', 'Google'] as const;
export type AllowedEngine = (typeof ALLOWED_ENGINES)[number];

export const DEFAULT_DAILY_DATA: OverviewDailyData = {
  desktop: {
    coverageComp: {},
  },
  mobile: {
    coverageComp: {},
  },
  unique_brands: [],
};

const DEFAULT_METRIC_DATA: MetricData = {
  coverage: {},
  rank: {},
  search_terms: {},
  Domain_Found_In_Serps: {},
  Total_Serps: {},
};

export const DEFAULT_DEVICE_AD_DATA: OverviewDeviceAdData = {
  ORGANIC: { ...DEFAULT_METRIC_DATA },
  PAID: { ...DEFAULT_METRIC_DATA },
  SHOPPING: { ...DEFAULT_METRIC_DATA },
};

export const DEFAULT_DEVICE_DATA: OverviewDeviceData = {
  current: {
    ORGANIC: {
      coverage: {},
      rank: {},
      search_terms: {},
      Domain_Found_In_Serps: {},
      Total_Serps: {},
    },
    PAID: {
      coverage: {},
      rank: {},
      search_terms: {},
      Domain_Found_In_Serps: {},
      Total_Serps: {},
    },
    SHOPPING: {
      coverage: {},
      rank: {},
      search_terms: {},
      Domain_Found_In_Serps: {},
      Total_Serps: {},
    },
  },
  previous: {
    ORGANIC: {
      coverage: {},
      rank: {},
      search_terms: {},
      Domain_Found_In_Serps: {},
      Total_Serps: {},
    },
    PAID: {
      coverage: {},
      rank: {},
      search_terms: {},
      Domain_Found_In_Serps: {},
      Total_Serps: {},
    },
    SHOPPING: {
      coverage: {},
      rank: {},
      search_terms: {},
      Domain_Found_In_Serps: {},
      Total_Serps: {},
    },
  },
};

// DEFAULT DATA
export const DEFAULT_OVERVIEW_DATA: OverviewData = {
  desktop: { ...DEFAULT_DEVICE_DATA },
  mobile: { ...DEFAULT_DEVICE_DATA },
  unique_brands: [],
};

export const COMP_INTEL_AD_TYPES = ['PAID', 'ORGANIC', 'SHOPPING'] as const;

export const providerChoices = [{ value: 'Oxylabs', label: 'Oxylabs' }];
